import request from '@/utils/request'

const baseApi = 'cust/customerAddress'

export default {
  fetchList(params) {
    return request({
      url: `${baseApi}`,
      method: 'get',
      params
    })
  },
  fetchById(id) {
    return request({
      url: `${baseApi}/tee/info`,
      method: 'get',
      params: { id }
    })
  },
  create(data) {
    return request({
      url: `${baseApi}`,
      method: 'post',
      data
    })
  },
  update(data) {
    return request({
      url: `${baseApi}`,
      method: 'put',
      data
    })
  },
  deleteById(id) {
    return request({
      url: `${baseApi}/${id}`,
      method: 'delete'
    })
  }
}

